import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDownIcon, UsersIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../context/AuthContext';

function AccountSwitcher() {
  const navigate = useNavigate();
  const { accounts, activeAccount, switchAccount } = useAuth();

  if (!activeAccount || accounts.length < 2) return null;

  const handleChange = (event) => {
    if (switchAccount(event.target.value)) navigate('/dashboard');
  };

  return (
    <label className="relative hidden items-center sm:flex">
      <UsersIcon className="pointer-events-none absolute left-2.5 h-4 w-4 text-blue-600" />
      <select
        aria-label="Active account"
        value={activeAccount.id}
        onChange={handleChange}
        className="appearance-none rounded-xl border border-blue-200 bg-blue-50 py-2 pl-8 pr-8 text-sm font-medium text-blue-900"
      >
        {accounts.map((account) => (
          <option key={account.id} value={account.id}>
            {account.isPersonal ? 'My Account' : account.name}
          </option>
        ))}
      </select>
      <ChevronDownIcon className="pointer-events-none absolute right-2.5 h-4 w-4 text-blue-600" />
    </label>
  );
}

export default AccountSwitcher;
